import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-bootstrap';
import Asset from '../../../components/stateless/Asset';
import MediaGalleryImage from '../../../../modules/react/components/stateful/MediaGalleryImage';
import classes from './Image.scss';

const ImageType = PropTypes.shape({
  file: PropTypes.string,
  filename: PropTypes.string,
  alt: PropTypes.string,
  link: PropTypes.string,
  mediumId: PropTypes.string,
  medium: PropTypes.shape(),
  target: PropTypes.string,
  title: PropTypes.string,
  staticImg: PropTypes.bool,
});

const propTypes = {
  images: PropTypes.arrayOf(ImageType),
  isBuilderView: PropTypes.bool,
};

const defaultProps = {
  images: [],
  isBuilderView: false,
};

const Image = ({ images, isBuilderView }) => {
  if ((!images || !images.length) && isBuilderView) {
    return <span>No images set.</span>;
  }

  if ((!images || !images.length) && !isBuilderView) {
    return null;
  }

  const classNames = [classes.root];
  if (images.length > 1) {
    classNames.push(classes.slideshow);
  }

  const renderAsset = (img, setMaxWidth) => (
    (!img.staticImg) ? (
      <MediaGalleryImage
        medium={img.medium}
        mediumFilename={img.filename}
        legacyImage={img}
        setMaxWidth={setMaxWidth}
      />
    ) : (
      <Asset
        file={img.file}
        alt={img.alt}
        title={img.title}
        setMaxWidth={setMaxWidth}
      />
    )
  );

  if (images.length === 1) {
    const img = images[0];
    const asset = renderAsset(img, true);
    classNames.push(classes.singleImage);
    return (
      <div className={classNames.join(' ')}>
        {img.link
          ? <a href={img.link} target={img.target}>{asset}</a>
          : asset
        }
      </div>
    );
  }

  return (
    <span>
      <Carousel
        indicators={false}
        controls={images.length > 1}
        className={classNames.join(' ')}
        prevIcon={<span className="icon icon-back-arrow" />}
        nextIcon={<span className="icon icon-select-arrow" />}
      >
        {images.map((img) => {
          const asset = renderAsset(img);
          return (
            <Carousel.Item key={img.file || img.mediumId} className="pb-no-click">
              {img.link && img.link.length
                ? <a href={img.link} target={img.target}>{asset}</a>
                : asset
              }
            </Carousel.Item>
          );
        })}
      </Carousel>
    </span>
  );
};

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

export default Image;
